import Swiper, { A11y } from 'swiper';

export default () => {
  // awards slider
  const awardsSwiper = new Swiper('.awards-wrap', {
    modules: [A11y],
    a11y: true,
    keyboardControl: true,
    grabCursor: true,
    watchOverflow: true,
    breakpoints: {
      320: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
    },
  });
};
